import * as React from 'react';
import { ICashOutListStore } from 'eTip--common';
import { CashOutListItem } from './cashOutListItem';

export interface ICashOutItemContainerProps {
    cashOutList: ICashOutListStore;
    onGoToDetail: (betId: number) => void;
}

export const CashOutItem = (props: ICashOutItemContainerProps) => {
    return <React.Fragment>
        {
            (props.cashOutList.bets.length > 0) &&
            props.cashOutList.bets.map((item) => <CashOutListItem
                key={item.betId}
                {...item}
                currency={props.cashOutList.currency}
                onGoToDetail={(betId) => { props.onGoToDetail(betId); }}
            />)

        }
    </React.Fragment>
}
